module.exports = __webpack_public_path__ + "img/MOSOBL.d92b9bc1.png";